import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks, site } from "../../mocks/site";

export default function SiteHeader() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const linkColor = transparent
    ? "text-background-50/95 hover:text-accent-300"
    : "text-foreground-800 hover:text-primary-600";

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent ? "bg-transparent py-3" : "bg-background-50/90 backdrop-blur-md shadow-soft py-2"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <Link
          to="/"
          className="flex items-center gap-2 whitespace-nowrap"
          aria-label="甜心剧情站首页"
        >
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-full text-xl ${
              transparent ? "bg-background-50/25 text-background-50" : "bg-primary-500 text-background-50"
            }`}
          >
            <i className="ri-heart-3-fill" />
          </span>
          <span className="hidden sm:block text-left leading-none">
            <span className={`block font-display text-lg ${transparent ? "text-background-50" : "text-primary-700"}`}>
              {site.name}
            </span>
            <span className={`block text-[11px] ${transparent ? "text-background-50/80" : "text-foreground-600"}`}>
              守护甜心剧情专题
            </span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : transparent
                    ? "text-background-50/95 hover:bg-background-50/20"
                    : "text-foreground-800 hover:bg-primary-100 text-primary-700"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:block">
          <Link
            to="/episodes"
            className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
              transparent
                ? "bg-background-50 text-primary-700 hover:bg-accent-300"
                : "bg-primary-500 text-background-50 hover:bg-primary-600"
            }`}
          >
            <i className="ri-movie-2-line" />
            从第一集看起
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`md:hidden flex h-10 w-10 items-center justify-center rounded-full text-xl ${
            transparent ? "bg-background-50/25 text-background-50" : "bg-background-100 text-foreground-800"
          }`}
          aria-label="打开菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"} />
        </button>
      </nav>

      {open && (
        <div className="md:hidden mx-4 mt-2 rounded-2xl bg-background-50 p-3 shadow-soft">
          {navLinks.map((link) => {
            const active = location.pathname === link.path;
            return (
              <Link
                key={link.path}
                to={link.path}
                className={`block rounded-xl px-4 py-3 text-sm ${
                  active ? "bg-primary-100 text-primary-700 font-medium" : "text-foreground-800"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>
      )}
    </header>
  );
}